// Import action types related to Tithi
import {
  TITHI_ARE_LOADING,
  TITHI_FETCH_DATA_SUCCESS,
  TITHI_HAVE_ERROR,
} from "../actionType";

// Define the initial state for the Tithi reducer
const initialState = {
  data: [], // Initialize data as an empty array
  loading: true, // Set loading to true initially
  error: [], // Initialize error as an empty array
};

// Reducer function to handle Tithi-related actions and update state accordingly
export function TithiReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching Tithi
    case TITHI_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when Tithi is being fetched
    case TITHI_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when Tithi is successfully fetched
    case TITHI_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.Tithi, // Update the data state with the fetched Tithi
        loading: false, // Set loading to false since the request is complete
        error: [], // Clear any previous errors (assuming the success case means no error)
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
